(function (Drupal) {
  function Tabs() {
    // on page /basket/
    document.querySelectorAll(".tab_content").forEach(function (tab) {
      tab.style.display = "none";
    });
    document.querySelector(".tab_content").style.display = "block";
    document.querySelectorAll(".tab_head li").forEach(function (item) {
      item.addEventListener("click", function () {
        document.querySelectorAll(".tab_content").forEach(function (tab) {
          tab.style.display = "none";
        });
        var activeTab = this.getAttribute("rel");
        document.getElementById(activeTab).style.display = "block";
        document.querySelectorAll(".tab_head li").forEach(function (li) {
          li.classList.remove("active");
        });
        this.classList.add("active");
      });
    });
  }

  function Sorting_manipulate() {
    if (typeof Drupal.Ajax === "undefined") return;

    // Сторінки таксономій (фасети) — фікс сортування для views
    Drupal.Ajax.prototype.beforeSumbitCommerceAddToCart = Drupal.Ajax.prototype.beforeSubmit;
    Drupal.Ajax.prototype.beforeSubmit = function (form_values, element_settings, options) {
      if (this.callback !== undefined) {
        const url_parts = options.url.split("?");
        if (this.callback === "::refreshAddToCartForm") {
          if (options.url.indexOf("/views/ajax") !== -1) {
            options.url = "?" + url_parts[1];
            return this.beforeSumbitCommerceAddToCart.apply(this, arguments);
          }
        }
      }
    };
  }

  Drupal.behaviors.tiunTermsSorting = {
    attach: function () {
      Sorting_manipulate();
      Tabs();
    },
  };
})(Drupal);
